import appVariablePlan from "../../views/appPlans/variable.html";
import constants from "../../core/constants";

function urlsConfig($stateProvider) {
  "ngInject";

  $stateProvider.state("variableplan", {
    url: "variable-plan/:id",
    parent: "app",
    views: {
      view: {
        template: appVariablePlan,
      },
    },
    reloadOnSearch: false,
    data: { title: "VariablePlan" + constants.titleBase },
  });
}

export default urlsConfig;



// WEBPACK FOOTER //
// ./src/pages/variablePlan/variablePlan.urls.js